import type { ReactNode } from 'react';

export interface AlertProps {
  type: 'success' | 'error' | 'warning' | 'info';
  children: ReactNode;
  onDismiss?: () => void;
}

export function Alert({ type, children, onDismiss }: AlertProps) {
  return (
    <div className={`alert alert-${type}`} role="alert">
      <div className="alert-content">{children}</div>
      {onDismiss && (
        <button className="alert-dismiss" onClick={onDismiss} aria-label="Dismiss alert">
          &times;
        </button>
      )}
    </div>
  );
}

export default Alert;
